import { push } from 'redux-first-router';

import { Button } from '@simplywallst/ui-core';
import { getPath } from '@/router/utils';
import { ROUTE_PUBLIC_NARRATIVE_CREATE } from '@/constants/routes';

import { FairValueTooltip } from './components/FairValueTooltip';
import { TitleWithTooltip } from '../TitleWithTooltip';
import { usePathname } from '@/hooks/location/usePathname';
import { useTracking } from 'react-tracking';
import { NARRATIVE_USER_POSITION } from '@/pages/Narrative/utils/schema';
import { narrativeFvModalReturnPath } from '../../utils';

type Props = {
  companyId: string;
  userHoldsPosition?: boolean;
};

export const ValuationOptionBuildMyNarrative = ({
  companyId,
  userHoldsPosition,
}: Props) => {
  const { trackEvent } = useTracking();

  const pathname = usePathname();

  const createNarrative = () => {
    trackEvent({
      action: 'click',
      target: 'create-narrative',
      valuationType: 'user_defined',
    });

    push(
      getPath({
        type: ROUTE_PUBLIC_NARRATIVE_CREATE,
        payload: {
          query: {
            company: companyId,
            returnPath: narrativeFvModalReturnPath(pathname, companyId),
            ...(userHoldsPosition
              ? { position: NARRATIVE_USER_POSITION.HOLDS }
              : {}),
          },
        },
      })
    );
  };

  return (
    <div
      className="grid grid-rows-[max-content_max-content] items-center justify-between
      gap-4 bg-surface-2
      p-6 min-[375px]:rounded-x1
      sm:grid-cols-[1fr_max-content] sm:grid-rows-[max-content]"
    >
      <div>
        <TitleWithTooltip tooltip={<FairValueTooltip />}>
          My Fair Value
        </TitleWithTooltip>
        <div className="text-xs text-soft">
          Create your own narrative on this stock, and estimate its Fair Value
          using our Valuator tool
        </div>
      </div>

      <Button styleType="loudLarge" onClick={createNarrative}>
        Build My Narrative
      </Button>
    </div>
  );
};
